const ScormEvents = {   
    CHANGE: 'change', 
    START: 'start', 
    FINISH: 'finish' 
};

const VIDEO_MODEL = {
    type: 'VIDEO',
    cmi: {
        position: 0,
        time_spent: '',
        student_id: '',
        student_name: '',
        finished: false,
        started: false
    }
};

export class VideoRuntime {

    /********************************************
     * Constructor
     * 
     * 'callbacks' can be one or all of:
     * initialize, change, commit, finish, error
     ********************************************/
    
    constructor( { CMIModel, debug = false, studentName = '', studentId = '', eventCallbacks = {} } ) {
        this.debug = debug;
        
        const newModel = { ...VIDEO_MODEL };
        newModel.cmi.student_name = studentName;
        newModel.cmi.student_id = studentId;
 
        // If CMI model doesn't exist or is blank
        if ( !CMIModel || Object.keys( CMIModel ).length === 0 ) {
            this.model = VIDEO_MODEL;
        } else {
            // Check SCORM version before using it in this.model
            // If it's not this version use a blank SCORM_12_CMI_MODEL
            if ( CMIModel.cmi?._BIW_SCORM_version === 'Video' ) {
                this.model = CMIModel;
            } else {
                this.model = VIDEO_MODEL;
            }
        }

        this.eventCallbacks = eventCallbacks;
        
        this.debug && console.log( 'Initial CMIModel:', this.model );
    }
   
    /**************************
     * SCORM Events
     **************************/
    
     handleProgress( e ) {
        this.debug && console.log( 'Change event' );

        // If video not started return
        if ( !this.model.cmi.started ) {
            return false;
        }

        this.model.cmi.position = Math.trunc( e.time );
        
        this.triggerCallback( ScormEvents.CHANGE, this.model );
        
        return true;
    }

    handleStart() {
        this.debug && console.log( 'Start event' );
        
        this.model.cmi.started = true;
        
        this.triggerCallback( ScormEvents.START, this.model );
        
        return true;
    }
  
    handleFinish() {
        this.debug && console.log( 'Finish event' );
        
        this.model.cmi.finished = true;

        this.triggerCallback( ScormEvents.FINISH, this.model );
        
        return true;
    }
  
    LMSSetValue( element, value ) {
        this.debug && console.log( 'SetValue:', element, value );

        const result = this.setCMIValue( element, value );
        this.triggerCallback( ScormEvents.CHANGE );

        return result;
    }
    
    LMSGetValue( element ) { 
        this.debug && console.log( `GetValue: ${ element }: ${ this.getCMIValue( element ) }` );
        
        return this.getCMIValue( element );
    }
 
    /**************************
     * Event handlers
     **************************/
   
    triggerCallback( eventName ) {
        if ( !this.eventCallbacks[ eventName ] ) {
            this.debug && console.log( `Event callback ${ eventName } does not exist` );
            return;
        }

        this.eventCallbacks[ eventName ]( eventName, this.model );
    }

    // /**************************
    //  * Utility Functions
    //  **************************/
    
    // getCMIValue ( keyPath ) {
    //     const searchKeys = keyPath.split( '.' );
    //     let index = 0;

    //     function getKey( JSObject ) {
    //         const fkey = JSObject[ searchKeys[ index ] ] ;
     
    //         if ( fkey === undefined ) {
    //             return undefined;
    //         }

    //         if ( typeof fkey === 'object' && fkey !== null && !Array.isArray( fkey ) && index < searchKeys.length - 1 ) {
    //             index++;
    //             return getKey( fkey );
    //         } else {
    //             return fkey;
    //         }
    //     } 
        
    //     return  getKey( this.model ); 
    // }   
 
    // setCMIValue( keyPath, newValue ) {
    //     const searchKeys = keyPath.split( '.' );
    //     let index = 0;

    //     function getKey( JSObject ) {
    //         let fkey = JSObject[ searchKeys[ index ] ] ;
     
    //         if ( fkey === undefined ) {
    //             return undefined;
    //         }

    //         if ( typeof fkey === 'object' && fkey !== null && !Array.isArray( fkey ) && index < searchKeys.length - 1 ) {
    //             index++;
    //             return getKey( fkey );
    //         } else {
    //             JSObject[ searchKeys[ index ] ]  = newValue;
    //             return newValue;
    //         }
    //     } 
       
    //     return getKey( this.model );       
    // } 
}
